import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'components/styles/login-header.css';
import useSmallScreenSize from 'hooks/useSmallScreenSize';
import { ROUTES } from 'constants';
import Cookies from 'universal-cookie';
import { ReactComponent as Carrefour } from 'assets/images/carrefour.svg';
import { ReactComponent as CarrefourLogo } from 'assets/images/carrefour-logo.svg';
import { ReactComponent as MajidIcon } from 'assets/images/majid-icon.svg';

const Header = () => {
  const isSmallScreen = useSmallScreenSize();
  const [openDialogBox, setOpenDialogBox] = useState(false);
  const navigate = useNavigate();

  const cookies = new Cookies();

  const clearAllCookies = () => {
    const allCookies = cookies.getAll();
    Object.keys(allCookies).forEach((cookieName) => {
      cookies.remove(cookieName, { path: '/' });
    });
  };

  const logout = () => {
    clearAllCookies();
    window.history.pushState({}, '', '/');
    navigate(`${ROUTES.ADMIN_PAGE.LOGIN}`);
  };

  const updatePassword = () => {
    navigate('/update-password');
  };

  return (
    <header>
      <div className="nav">
        <div className="login-nav-left">
          <div className="logo" onClick={() => navigate('/home')}>
            {isSmallScreen ? (
              <MajidIcon/>
            ) : (
              <div className="carrefourLogoHeader">
                <CarrefourLogo />
                <Carrefour />
              </div>
            )}
          </div>
          <div className="headline">Admin Portal</div>
        </div>
        <div className="header-logout">
          <div className="header-hi">Hi, Welcome back</div>
          <div className="header-admin" onClick={() => setOpenDialogBox(!openDialogBox)}>
            Admin
          </div>

          <div className={`logout-toggle-dialog ${!openDialogBox ? 'hideLogoutDialog' : ''}`}>
            <div
              onClick={() => {
                updatePassword();
                setOpenDialogBox(false);
              }}>
              Update password
            </div>
            <div onClick={logout}>Logout</div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
